var _g, _path, _path2, _path3, _path4, _path5, _path6, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShrine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8357",
    "data-name": "Group 8357",
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.945,
    height: 112.723,
    viewBox: "0 0 93.945 112.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6500",
    "data-name": "Group 6500",
    transform: "translate(45.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157958",
    "data-name": "Path 157958",
    d: "M83.3,8.7V30.98l28.08-4.249-8.5-4.766,13.782-4.249Z",
    transform: "translate(-81.405 -3.704)",
    fill: "#ee2a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157959",
    "data-name": "Path 157959",
    d: "M81.091,0h1.55a1.09,1.09,0,0,1,1.091,1.091V39.852H80V1.091A1.056,1.056,0,0,1,81.091,0Z",
    transform: "translate(-80)",
    fill: "#752f28"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6499",
    "data-name": "Group 6499",
    transform: "translate(7.867 11.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157960",
    "data-name": "Path 157960",
    d: "M99.27,27.307h0a.7.7,0,0,0,.172.517.692.692,0,0,0,.287.287.652.652,0,0,0,.459.172,1.505,1.505,0,0,0,.861-.115,2.356,2.356,0,0,0,.919-.919,1.082,1.082,0,0,0,.115-.459v-.4a2.027,2.027,0,0,0-.172-.8c-.057-.057-.057-.115-.115-.23a.793.793,0,0,0-.23-.172c-.115,0-.287-.057-.4-.057a.816.816,0,0,0-.345.115l-.345.345-.345.517a4.964,4.964,0,0,1-.4.574c-.057.057-.115.115-.172.115a.422.422,0,0,1-.345.115h-.861c.057.115.115.287.172.4a1.676,1.676,0,0,1,.115.517,1.236,1.236,0,0,1,0,.459,1.834,1.834,0,0,1-.172.8,2.328,2.328,0,0,1-.287.517,1.8,1.8,0,0,1-.632.517.926.926,0,0,1-.517.172,2.328,2.328,0,0,1-.632,0,2.149,2.149,0,0,1-1.034-.287,3.383,3.383,0,0,1-1.608-2.469,1.955,1.955,0,0,1-.057-.574v-.689l.057-.057a.056.056,0,0,1,.057.057c.057.115.057.172.115.287l.172.517a4.081,4.081,0,0,0,.459,1.034.844.844,0,0,0,.287.345,1.25,1.25,0,0,0,.459.287,1.529,1.529,0,0,0,.689.172,2.326,2.326,0,0,0,.632,0,1.158,1.158,0,0,0,.632-.172,1.117,1.117,0,0,0,.574-.689,1.14,1.14,0,0,0-.057-.632.828.828,0,0,0-.632-.517c-.172,0-.345-.057-.459,0h-.345L96,26.388a5.054,5.054,0,0,1-.287-.861h.057a1.264,1.264,0,0,1,.459.057,3.791,3.791,0,0,0,.8-.057.815.815,0,0,0,.517-.459c0-.057.057-.057.057-.115V24.78a.845.845,0,0,0-.287-.345.816.816,0,0,0-.345-.115,1.59,1.59,0,0,0-.517.057,6.442,6.442,0,0,0-.746.287c-.172.057-.287.172-.459.23h-.057c-.23-.345-.4-.689-.632-1.091a.793.793,0,0,1,.23-.172,2.134,2.134,0,0,1,1.091-.517A2.064,2.064,0,0,1,96.514,23H97.2a.976.976,0,0,1,.574.345,1.75,1.75,0,0,1,.459.919,1.414,1.414,0,0,1-.057.689,2.253,2.253,0,0,1-.459.8.573.573,0,0,1-.287.23c-.057.057-.115.057-.172.115h.057a2.8,2.8,0,0,0,.4.172.518.518,0,0,0,.287.057.652.652,0,0,0,.459-.172,1.522,1.522,0,0,0,.287-.345c.115-.172.172-.345.287-.517a2.371,2.371,0,0,1,.4-.632,1.548,1.548,0,0,1,.459-.4c.172-.057.287-.115.459-.172a1.174,1.174,0,0,1,.632,0,1.032,1.032,0,0,1,.517.23,2.146,2.146,0,0,1,.747.861,5.049,5.049,0,0,1,.287.861,6.236,6.236,0,0,1,.057,1.034,3.9,3.9,0,0,1-.172,1.091,3.092,3.092,0,0,1-.4.747,1.268,1.268,0,0,1-.747.574,1.677,1.677,0,0,1-.517.115,2.356,2.356,0,0,1-.632-.057,1.022,1.022,0,0,1-.632-.459,1.94,1.94,0,0,1-.345-.689,3.36,3.36,0,0,1-.115-.747.977.977,0,0,1,.057-.4c.115.115.115.115.172.057Z",
    transform: "translate(-93.7 -21.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157961",
    "data-name": "Path 157961",
    d: "M100.415,21.157h0a1.8,1.8,0,0,0,.459.632,3.183,3.183,0,0,0,.459.345c.115.057.172.057.287.115a1.194,1.194,0,0,0,.632.057,2.036,2.036,0,0,0,.632-.172,4.792,4.792,0,0,0,.689-.459.793.793,0,0,0,.23-.172c.057-.057.057-.057.115,0,.115.115.172.23.287.345s.172.23.287.345a.2.2,0,0,0,.057.115v.057l-.115.115a1.745,1.745,0,0,1-.4.287,2.123,2.123,0,0,1-.632.287.728.728,0,0,1-.345.057,1.59,1.59,0,0,1-.517.057,3.531,3.531,0,0,1-.8-.057,2.151,2.151,0,0,1-.689-.4,2.249,2.249,0,0,1-.459-.574l-.172-.345a1.352,1.352,0,0,1-.115-.459V21.1c.057.115.057.057.115.057Z",
    transform: "translate(-96.51 -20.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157962",
    "data-name": "Path 157962",
    d: "M102.8,20c.287.287.632.574.919.861h0l-.4.4-.345.345c-.057,0-.057.057-.115.057H102.8c-.172-.115-.287-.23-.459-.345a1.521,1.521,0,0,1-.287-.345L102,20.919v-.057c.23-.23.4-.459.632-.689.057-.057.115-.057.172-.172Z",
    transform: "translate(-97.234 -20)",
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_157963",
    "data-name": "Path 157963",
    d: "M4.431,174.2H91.715a3.333,3.333,0,0,1,3.331,3.331v9.36H1.1v-9.36A3.333,3.333,0,0,1,4.431,174.2Z",
    transform: "translate(-1.1 -74.168)",
    fill: "#f8991d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_157964",
    "data-name": "Path 157964",
    d: "M16.731,152.1H89.888a3.333,3.333,0,0,1,3.331,3.331v9.36H13.4v-9.36A3.333,3.333,0,0,1,16.731,152.1Z",
    transform: "translate(-6.4 -64.759)",
    fill: "#f8991d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_157965",
    "data-name": "Path 157965",
    d: "M24.131,130H88.847a3.333,3.333,0,0,1,3.331,3.331v9.36H20.8v-9.36A3.333,3.333,0,0,1,24.131,130Z",
    transform: "translate(-9.488 -55.349)",
    fill: "#f8991d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_157966",
    "data-name": "Path 157966",
    d: "M33.931,107.8H87.392a3.333,3.333,0,0,1,3.331,3.331v9.36H30.6v-9.36A3.333,3.333,0,0,1,33.931,107.8Z",
    transform: "translate(-13.66 -45.897)",
    fill: "#f8991d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_157967",
    "data-name": "Path 157967",
    d: "M46.231,85.8H85.566A3.333,3.333,0,0,1,88.9,89.131v9.36h-46v-9.36A3.3,3.3,0,0,1,46.231,85.8Z",
    transform: "translate(-18.897 -36.53)",
    fill: "#f8991d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_157968",
    "data-name": "Path 157968",
    d: "M58.531,63.7H83.74a3.333,3.333,0,0,1,3.331,3.331v9.36H55.2v-9.36A3.262,3.262,0,0,1,58.531,63.7Z",
    transform: "translate(-24.134 -27.12)",
    fill: "#f8991d"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8358",
    "data-name": "Group 8358",
    transform: "translate(-51 -26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3296",
    "data-name": "Rectangle 3296",
    width: 3.641,
    height: 5.223,
    transform: "translate(96.482 75.175)",
    fill: "#fcf1df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3297",
    "data-name": "Rectangle 3297",
    width: 3.641,
    height: 5.223,
    transform: "translate(96.482 85.621)",
    fill: "#fcf1df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3298",
    "data-name": "Rectangle 3298",
    width: 3.641,
    height: 5.223,
    transform: "translate(96.482 97.809)",
    fill: "#fcf1df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3299",
    "data-name": "Rectangle 3299",
    width: 3.641,
    height: 5.223,
    transform: "translate(96.482 108.255)",
    fill: "#fcf1df"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3300",
    "data-name": "Rectangle 3300",
    transform: "translate(93 119.571)",
    fill: "#fcf1df",
    stroke: "#fcf1df",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.446,
    height: 19.151,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 8.946,
    height: 17.651,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShrine);
export default __webpack_public_path__ + "static/media/shrine.eaa726b8fd56a4306bfdaf618b0b97d2.svg";
export { ForwardRef as ReactComponent };